export default __webpack_public_path__ + "static/AGaramondPro-Regular-c8361307433066597deb22da6bd02e4c.otf";